import React from 'react';
import { Button, Tooltip } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

/**
 * The Tags-page export control (CP-8289): outlined, upload icon, the word
 * Export, and a tooltip that names the file format. `anchorStyle` sits on
 * the tooltip wrapper so a position:fixed header button stays pinned to
 * the viewport instead of to an empty span in normal flow.
 */
const OutlinedExportButton = ({
    onClick,
    tooltip,
    disabled = false,
    size = 'small',
    label = 'Export',
    hideLabel = false,
    icon,
    sx,
    anchorStyle,
    fullWidth = false,
}) => {
    const button = (
        <Button
            onClick={onClick}
            variant="outlined"
            color="primary"
            size={size}
            disabled={disabled}
            fullWidth={fullWidth}
            aria-label={label}
            sx={{ whiteSpace: 'nowrap', ...(hideLabel ? { minWidth: 0 } : null), ...sx }}
        >
            {icon || <FileUploadOutlinedIcon />}
            {!hideLabel && <>&nbsp;{label}</>}
        </Button>
    );
    if (!tooltip) return button;
    return (
        <Tooltip title={tooltip}>
            <span style={{
                display: fullWidth ? 'flex' : 'inline-flex',
                flex: fullWidth ? '1 1 auto' : undefined,
                width: fullWidth ? '100%' : undefined,
                ...anchorStyle,
            }}
            >
                {button}
            </span>
        </Tooltip>
    );
};

export default OutlinedExportButton;
